// extracted by mini-css-extract-plugin
export var brand = "_25-9";
export var compact = "_25-6";
export var extraSmall = "_25-7";
export var icon = "_25-0";
export var large = "_25-4";
export var light = "_25-1";
export var medium = "_25-5";
export var outline = "_25-b";
export var primaryDark = "_25-a";
export var primaryLight = "_25-8";
export var primaryModern = "_25-c";
export var success = "_25-2";
export var successSolid = "_25-3";